import { render, staticRenderFns } from "./BusinessEntitiesList.vue?vue&type=template&id=5cc23725&scoped=true&"
import script from "./BusinessEntitiesList.vue?vue&type=script&lang=js&"
export * from "./BusinessEntitiesList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessEntitiesList.vue?vue&type=style&index=0&id=5cc23725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc23725",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc23725')) {
      api.createRecord('5cc23725', component.options)
    } else {
      api.reload('5cc23725', component.options)
    }
    module.hot.accept("./BusinessEntitiesList.vue?vue&type=template&id=5cc23725&scoped=true&", function () {
      api.rerender('5cc23725', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BusinessEntities/components/BusinessEntitiesList.vue"
export default component.exports